import { applyPromoOverride } from 'yoda-core-components/lib/helpers/Stylitics';
import { shopTheImageItemClick, shopTheImageLoadSuccess } from '../../../actions/AnalyticsAction';
import { miniPDPOnShopTheImageOpen } from '../../../actions/MiniPDPAction';

let _onOutfitsLoaded = null;
let _onItemClick = null;

const shopTheImageConfig = {
    id: 'shop-the-image',
    containerId: 'shopTheImageContainer',
    title: null,
    featureFlagKey: 'enableStyliticsShopTheImage',
    requiresItemNumber: false,

    getScriptURL: (prefs) => prefs?.styliticsWidget?.scriptURL || '',

    createWidget: async (itemNumber) => {
        if (typeof StyliticsComposer === 'undefined') {
            throw new Error('StyliticsComposer is not available');
        }
        return StyliticsComposer.initialize({
            client: 'jcpenney',
            target: 'shopTheImageContainer',
            config: {
                modules: [
                    {
                        type: 'shop-similar',
                        params: {
                            display: {
                                dialogAsModal: false,
                                shopButtonMargin: 8,
                            },
                        },
                        on: {
                            'mount.collection': ({ collection }) => {
                                _onOutfitsLoaded?.(collection);
                            },
                            'mount.item': ({ item, element }) => {
                                applyPromoOverride(element, item);
                            },
                        },
                        override: {
                            'click.item': (data) => {
                                _onItemClick?.(data?.item, data?.outfit);
                            },
                        },
                    },
                ],
            },
        });
    },

    registerEvents: (instance, { onOutfitsLoaded, onItemClick }) => {
        _onOutfitsLoaded = onOutfitsLoaded;
        _onItemClick = onItemClick;
    },

    refresh: () => {},

    analyticsLoadAction: shopTheImageLoadSuccess,
    analyticsClickAction: ({ id, ppId }) =>
        shopTheImageItemClick({
            shopTheImageID: id?.toString() || '',
            shopTheImagePPID: ppId,
            moduleName: 'shop the image',
        }),
    miniPDPAction: miniPDPOnShopTheImageOpen,
    analyticsModule: 'shop the image',
};

export default shopTheImageConfig;
